// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v--modal-box>iframe[data-v-86f7883c]{width:100%;max-width:650px}", ""]);
// Exports
module.exports = exports;
